export const containerComponentOverrides = {
    MuiContainer: {
        styleOverrides: {
            root: ({ theme }) => ({
                paddingLeft: theme.tokens.FuelSpacing4,
                paddingRight: theme.tokens.FuelSpacing4,
                [theme.breakpoints.up('sm')]: {
                    paddingLeft: theme.tokens.FuelSpacing4,
                    paddingRight: theme.tokens.FuelSpacing4
                },
                '&.MuiContainer-disableGutters': {
                    paddingLeft: 0,
                    paddingRight: 0
                }
            })
        }
    }
};
